
import {  
  Directive,  
  Input,  
  TemplateRef  
} from '@angular/core';  
@Directive({  
  selector: '[dynamic]'  
})  
export class DynamicTemplateDirective {  
  @Input('dynamic') name: string;  
  constructor(public template: TemplateRef < any > ) {}  
} 